import User from "../../models/user.model";
import { ReducerBuilder } from "../../utils/redux/reducer-builder";
import { GlobalTypes } from "./../global-types";
import { AuthActionTypes, AuthState, INITIAL_STATE } from "./auth-types";

const reduxBuilder = new ReducerBuilder<AuthState>(INITIAL_STATE);

reduxBuilder.addReducer(GlobalTypes.CLEAR, () => {
  return INITIAL_STATE;
});

reduxBuilder.addMutableReducer(GlobalTypes.LOGOUT, (state) => {
  state.wasLogoutSolicited = true;
});

reduxBuilder.addMutableReducer<{ token: string }>(
  AuthActionTypes.UPDATE_AUTHENTICATION_TOKEN,
  (state, payload) => {
    if (payload.token) {
      state.authenticated = true;
      state.token = payload.token;
    }
  }
);

reduxBuilder.addMutableReducer<{ user: User }>(
  AuthActionTypes.SETUP_COMPLETED,
  (state, payload) => {
    state.user = payload.user;
  }
);

reduxBuilder.addMutableReducer<{ user: User }>(
  AuthActionTypes.GET_USER_SUCCESS,
  (state, payload) => {
    state.user = payload.user;
  }
);

reduxBuilder.addMutableReducer(
  AuthActionTypes.GET_USER_ERROR,
  (state, payload) => {
    
  }
);

reduxBuilder.addMutableReducer(
  AuthActionTypes.UPDATE_TERM_ACCEPT_SUCCESS,
  (state) => {
    state.updateTermAccept = true;
  }
);

reduxBuilder.addMutableReducer(
  AuthActionTypes.UPDATE_TERM_ACCEPT_ERROR,
  (state) => {
    state.updateTermAccept = false;
  }
);

reduxBuilder.addMutableReducer<{ by_action: boolean }>(AuthActionTypes.FETCH_SHOW_ACCOUNT_CONFIRMATION_MODAL, (state, payload) => {
  state.accountConfirmation = {
    ...INITIAL_STATE.accountConfirmation,
    showModal: true,
    byAction: payload.by_action,
  };
});

reduxBuilder.addMutableReducer(AuthActionTypes.FETCH_HIDE_ACCOUNT_CONFIRMATION_MODAL, (state) => {
  state.accountConfirmation = {
    ...INITIAL_STATE.accountConfirmation,
    showModal: false,
    byAction: false,
    errorMessage: undefined,
  };
});  

reduxBuilder.addMutableReducer(AuthActionTypes.SEND_EMAIL_ACCOUNT_CONFIRMATION_SUCCESS, (state) => {
  state.accountConfirmation = {
    ...INITIAL_STATE.accountConfirmation,
    showModal: false,
    byAction: false,
    errorMessage: undefined,
  };
});

reduxBuilder.addMutableReducer<{ status: number }>(AuthActionTypes.SEND_EMAIL_ACCOUNT_CONFIRMATION_ERROR, (state, payload) => {
  const getMessageKey = (status: number): string => {
    switch (status) {
      case 404:
        return `error.not-found`;
      case 409:
        return `error.conflict`;
      case 406:
        return `error.not-acceptable`;
      default:
        return `error.default`;
    }
  };

  state.accountConfirmation = {
    ...INITIAL_STATE.accountConfirmation,
    showModal: true,
    byAction: false,
    errorMessage: getMessageKey(payload.status),
  };
});

reduxBuilder.addMutableReducer(AuthActionTypes.ACCOUNT_CONFIRMATION, (state) => {
    state.accountConfirmation = {
        ...state.accountConfirmation,
        confirmationLoading: true,
        confirmationSuccess: false,
        confirmationErrorMessage: undefined,
    };
});

reduxBuilder.addMutableReducer(AuthActionTypes.ACCOUNT_CONFIRMATION_SUCCESS, (state) => {
    state.accountConfirmation = {
        ...state.accountConfirmation,
        confirmationLoading: false,
        confirmationSuccess: true,
        confirmationErrorMessage: undefined,
    };
});

reduxBuilder.addMutableReducer<{ status: number }>(AuthActionTypes.ACCOUNT_CONFIRMATION_ERROR, (state, payload) => {
    const getMessageKey = (status: number): string => {
        const root = "error";
        console.log(status);
        switch (status) {
            case 404:
                return `${root}.notFound`;
            case 401:
                return `${root}.unauthorized`;
            default:
                return `${root}.default`;
        }
    };

    state.accountConfirmation = {
        ...state.accountConfirmation,
        confirmationLoading: false,
        confirmationSuccess: false,
        confirmationErrorMessage: getMessageKey(payload.status),
    };
});

export default reduxBuilder.build();

